import React from 'react';
import TooltipBubble from '../Shared/TooltipBubble';

/**
 * Small `?` button that reveals a tooltip explaining the travel fee basis.
 * Public-booking themed wrapper over the shared TooltipBubble shell (keyboard +
 * hover accessible, ARIA-wired).
 *
 * Copy is generic-but-truthful: explains that a fee applies and roughly why
 * (mobile service), without disclosing rates, distances, units, or provider
 * location. See travel-fee-tooltip-privacy-fix.md for rationale.
 *
 * @param {Object} bookingPage - Public booking page data (travelFeeType exposed).
 * @param {boolean} isDark - Whether dark theme is active.
 */
const TravelFeeTooltip = ({ bookingPage, isDark }) => {
  const travelFeeType = bookingPage?.travelFeeType;

  let tooltipText;
  if (travelFeeType === 'distance') {
    tooltipText = 'This fee covers travel for your mobile appointment and is based on the distance to your location.';
  } else if (travelFeeType === 'flat') {
    tooltipText = 'A flat fee applies for mobile appointments, regardless of distance.';
  } else {
    // Defensive fallback for legacy pages or pages where the field is missing.
    tooltipText = 'This fee covers travel for your mobile appointment.';
  }

  return (
    <TooltipBubble
      content={tooltipText}
      ariaLabel={`Travel fee info: ${tooltipText}`}
      trigger="?"
      buttonClassName="badge-themed w-4 h-4 rounded-full text-xs font-bold flex items-center justify-center
        focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-themed-ring
        transition-opacity cursor-help hover:opacity-80"
      bubbleClassName={`pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 z-10
        w-max max-w-[220px] px-2.5 py-1.5 rounded text-xs leading-snug shadow-lg
        opacity-0 group-hover:opacity-100 group-focus-within:opacity-100
        transition-opacity duration-150
        ${isDark
          ? 'bg-ink-900 text-ink-50 border border-ink-600'
          : 'bg-ink-800 text-white'
        }`}
      arrowClassName={`absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent
        ${isDark ? 'border-t-ink-900' : 'border-t-ink-800'}`}
    />
  );
};

export default TravelFeeTooltip;
